/* ControlAppNavAddon.js */

"use strict";

const EventEmitter = require("events").EventEmitter,
    HomeBar = require("../HomeBar/HomeBarComponent"),
    _ = require("lodash"),
    HELP_MAP = require("../sectionmappings/helpLinkMapping"),
    SECTION_TITLES = require("../sectionmappings/documentTitleMapping"),
    DASHBOARD_TITLE = "My Dashboards";
const SOLUTION_USER_PERM_MAP = require("../SolutionPermsMap");
const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19";

// Permissions that grant access to the Gluware Titan (Co-Pilot) feature.
const DOC_ASSIST_PERMISSION = "docAssistAccess"; // legacy ("Access Document Assist assistant")
const TITAN_PERMISSION = "docAssistAccessAndTitan"; // new RBAC ("Access Gluware Titan and Document Assist assistants")
const TAI_LICENSE = "TAI";

class ControlAppNavAddon extends EventEmitter {
    constructor(
        logger,
        userSession,
        userFeedback,
        router,
        localStorage,
        solutionManager,
        storageFactory,
        ControlUser,
        ActionGroup,
        OsUpgradePlanPrefs,
        GenAiServiceIns,
        SystemConfig,
        VersionControlConfig,
        DataSyncConfig,
        GenAiConfig
    ) {
        super();
        this._logger = logger;
        this._userSession = userSession;
        this._userFeedback = userFeedback;
        this._router = router;
        this._localStorage = localStorage;
        this._storageFactory = storageFactory;
        this._dataStorage = undefined;
        this._solutionManager = solutionManager;
        this._ControlUserEntity = ControlUser;
        this._ActionGroupEntity = ActionGroup;
        this._OsUpgradePlanPrefs = OsUpgradePlanPrefs;
        this._genAiServiceIns = GenAiServiceIns;
        this._systemConfigEntityDef = SystemConfig;
        this._versionControlConfigEntityDef = VersionControlConfig;
        this._dataSyncConfigEntityDef = DataSyncConfig;
        this._genAiConfigEntityDef = GenAiConfig;

        this._sessionStorage = window.sessionStorage;
        this._token = undefined;
        this._controluserInstance = undefined;

        this._homebar = new HomeBar({
            shown: false,
            solutionManager: this._solutionManager,
            storageFactory: this._storageFactory,
        });
        this._logoutPreChecks = [];
        this._hasUserSignedOut = false;

        this._versionControlLocalEnabled = false;
        this._versionControlPendingCommitCount = 0;

        this._xDomeEnabled = false;

        this._setInitialValuesOnHomeBar = _.debounce(
            this._setInitialValuesOnHomeBar.bind(this),
            500
        );

        this._roboHelpTab = undefined;
        this._helpMap = HELP_MAP;
        this._section_titles = SECTION_TITLES;
        this._registerListeners();
        this._registerSolutionChangeListener();
    }

    get xDomeEnabled() {
        return this.getXDomeEnabledValue();
    }

    getXDomeEnabledValue() {
        return this._xDomeEnabled;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    _registerListeners() {
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChanged = this._onOrganizationChanged.bind(this))
        );
        this._userSession.on(
            "Authenticated",
            (this._onAuthenticated = this._onAuthenticated.bind(this))
        );
        this._userSession.on(
            "UnAuthenticated",
            (this._onUnAuthenticated = this._onUnAuthenticated.bind(this))
        );
        this._userSession.on(
            "NotAuthenticated",
            (this._onNotAuthenticated = this._onNotAuthenticated.bind(this))
        );
        this._userSession.on(
            "ConnectionLost",
            (this._onConnectionLost = this._onConnectionLost.bind(this))
        );
        this._userSession.on(
            "ConnectionShutdown",
            (this._onConnectionShutdown = this._onConnectionShutdown.bind(this))
        );
        this._homebar.on(
            "OrganizationChange",
            (this._onHomeBarRequestedOrganizationChange =
                this._onHomeBarRequestedOrganizationChange.bind(this))
        );
        this._homebar.on(
            "HelpSelected",
            (this._onHomeBarRequestedHelp = this._onHomeBarRequestedHelp.bind(this))
        );
        this._homebar.on(
            "MenuSelected",
            (this._onHomeBarRequestedNavigateToDashboard =
                this._onHomeBarRequestedNavigateToDashboard.bind(this))
        );
        this._homebar.on(
            "TitleSelected",
            (this._onHomeBarRequestedNavigateToDashboard =
                this._onHomeBarRequestedNavigateToDashboard.bind(this))
        );
        this._homebar.on(
            "LogOutSelected",
            (this._onHomeBarRequestedLogout = this._onHomeBarRequestedLogout.bind(this))
        );
        this._homebar.on(
            "AutoShow",
            (this._onHomeBarAutoShow = this._onHomeBarAutoShow.bind(this))
        );
        this._homebar.on(
            "AutoHide",
            (this._onHomeBarAutoHide = this._onHomeBarAutoHide.bind(this))
        );
        this._router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = this._onRouteInfoChanged.bind(this))
        );
    }

    _registerVersionControlListeners() {
        this._versionControlEntityInstance.on(
            "PropertiesUpdated",
            (this._onVersionControlConfigChanged = this._onVersionControlConfigChanged.bind(this))
        );
    }

    _unregisterVersionControlListeners() {
        if (this._versionControlEntityInstance) {
            this._versionControlEntityInstance.removeListener(
                "PropertiesUpdated",
                this._onVersionControlConfigChanged
            );
        }
    }

    _unregisterListeners() {
        this._userSession.removeListener("OrganizationChange", this._onOrganizationChanged);
        this._userSession.removeListener("Authenticated", this._onAuthenticated);
        this._userSession.removeListener("UnAuthenticated", this._onUnAuthenticated);
        this._userSession.removeListener("NotAuthenticated", this._onNotAuthenticated);
        this._userSession.removeListener("ConnectionLost", this._onConnectionLost);
        this._userSession.removeListener("ConnectionShutdown", this._onConnectionShutdown);
        this._homebar.removeListener(
            "OrganizationChange",
            this._onHomeBarRequestedOrganizationChange
        );
        this._homebar.removeListener("HelpSelected", this._onHomeBarRequestedHelp);
        this._homebar.removeListener("MenuSelected", this._onHomeBarRequestedNavigateToDashboard);
        this._homebar.removeListener("TitleSelected", this._onHomeBarRequestedNavigateToDashboard);
        this._homebar.removeListener("LogOutSelected", this._onHomeBarRequestedLogout);
        this._homebar.removeListener("AutoShow", this._onHomeBarAutoShow);
        this._homebar.removeListener("AutoHide", this._onHomeBarAutoHide);
        this._router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
    }

    hideHomebar() {
        this._homebar.hide();
    }

    showHomebar() {
        this._homebar.show();
    }

    // eslint-disable-next-line no-unused-vars
    initialize(steve, addOnOptions) {
        document.body.appendChild(this._homebar.renderer.rootElement);
        let activeSolution = this._solutionManager.getActiveSolution();
        if (activeSolution) {
            this.setHomebar(activeSolution.label, activeSolution.iconName);
        } else if (this._getCurrentSection() === "Dashboard") {
            this.setHomebar(DASHBOARD_TITLE);
        }
        return Promise.resolve();
    }

    // eslint-disable-next-line no-unused-vars
    startUp(steve, addOnOptions) {
        document.title = _.get(
            this._section_titles,
            this._getCurrentSection(),
            this._section_titles.default
        );
    }

    shutdown() {
        this._unregisterListeners();
        this._unregisterVersionControlListeners();
        let promArr = [
            this._storageFactory ? this._storageFactory.shutdown : Promise.resolve,
            this._homebar.shutdown,
            this._versionControlEntityInstance
                ? this._versionControlEntityInstance.shutdown
                : Promise.resolve,
        ];
        return Promise.all(promArr)
            .then(() => {
                this._logger = undefined;
                this._userSession = undefined;
                this._homebar = undefined;
                this._logoutPreChecks = undefined;
                this._ControlUserEntity = undefined;
                this._ActionGroupEntity = undefined;
                this._controluserInstance = undefined;
                this._hasUserSignedOut = undefined;
                this._userFeedback = undefined;
                this._router = undefined;
                this._localStorage = undefined;
                this._storageFactory = undefined;
                this._dataStorage = undefined;
                this._solutionManager = undefined;
                this._OsUpgradePlanPrefs = undefined;
                this._sessionStorage = undefined;
                this._token = undefined;
                this._hasUserSignedOut = undefined;
                this._roboHelpTab = undefined;
                this._helpMap = undefined;
                this._section_titles = undefined;
                this._setInitialValuesOnHomeBar = undefined;
                this._versionControlConfigEntityDef = undefined;
                this._versionControlLocalEnabled = undefined;
                this._versionControlPendingCommitCount = undefined;
                this._dataSyncConfigEntityDef = undefined;
                this._versionControlEntityInstance = undefined;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "AppSolutionSwitcher addOn error");
            });
    }

    setHomebar(title = "", icon = "branding.control") {
        this._homebar.setTitle(title);
        this._homebar.setIcon(icon);
    }

    getUserPreferences() {
        const activeOrgId = _.get(this._userSession._activeOrganization, "id");
        return this._OsUpgradePlanPrefs.loadPrefs(activeOrgId).then((OsUpgradePlanPrefs) => {
            this._isCatalogEnable = _.get(OsUpgradePlanPrefs, "enableCatalogs");
            this._homebar.setIsCatalogEnabled(this._isCatalogEnable);
            return Promise.resolve();
        });
    }

    _routeToLogin() {
        let routeDetails = this._router.getRouteDetails();
        if (routeDetails) {
            if (routeDetails.s === "LoginCenter") {
                this._router.goTo({
                    app: "GameConsole",
                    s: "LoginCenter",
                    sln: null,
                    ra: "dashboard",
                });
            } else if (routeDetails.s === "LogoutCenter") {
                this._router.goTo({
                    app: "GameConsole",
                    s: "LogoutCenter",
                    sln: null,
                    ra: "dashboard",
                });
            } else {
                const token = this._userSession.token || this._localStorage.getToken();
                localStorage.clear();
                location.href = `${window.origin}/session/logout/${token}`;
            }
        }
    }

    _registerSolutionChangeListener() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onActiveSolutionChanged = this._onActiveSolutionChanged.bind(this))
        );
    }

    routeToDashboard() {
        this._homebar.blur();
        this.setHomebar(DASHBOARD_TITLE);
        this._router.goTo({
            app: "GameConsole",
            s: "Dashboard",
            sln: null,
            sr: null,
            rd: {},
            ra: "dashboard",
        });
        // Similar to the line above
        // window.location = window.origin + '/#!/_app_/GameConsole/_s_/Dashboard/_rd_/JTdCJTdE/_ra_/dashboard';
    }

    routeToLicensing() {
        this._homebar.blur();
        this._router.goTo({
            app: "GameConsole",
            s: "Settings",
            sln: "Settings",
            rd: {},
            sr: "Organization/Licensing",
        });
    }

    _setHomebarUserImage(userEntity) {
        return this._ControlUserEntity
            .loadControlUser(userEntity.tenantId, userEntity.id)
            .then((user) => {
                return this._homebar.setUserImage(user.image);
            });
    }

    _setHomebarRole(userEntity) {
        return this._ActionGroupEntity
            .loadAscendActionGroup(userEntity.tenantId, userEntity.actionGroupId)
            .then((group) => {
                return this._homebar.setRole(group.name);
            });
    }

    updateHomebarIoT() {
        const activeOrgId = _.get(this._userSession, "activeOrganization.id");

        // If user is not authenticated, data cannot be loaded
        if (!activeOrgId) {
            return;
        }

        return this._dataSyncConfigEntityDef
            .loadProviderConfig(activeOrgId, "claroty", "xdome")
            .then((dataSyncConfig) => {
                this._xDomeEnabled = Boolean(_.get(dataSyncConfig, "enabled", false));
                this._homebar.showItemsBasedOnXDome(this._xDomeEnabled);
            })
            .catch((err) => {
                this._logger.error(
                    {error: err},
                    err,
                    "ControlAppNavAddon: updateHomebarIoT - Cannot refresh IoT icon"
                );
            });
    }

    _updateGenAiState() {
        // Refresh the Gluware Titan (GenAI) icon visibility/enablement based on the
        // current org's GenAiConfig and the global Document Assist setting.
        const licenseRestriction = this._homebar && this._homebar.licenseRestriction;
        const licenseReady = licenseRestriction
            ? licenseRestriction.whenLicenseFeedIsReady()
            : Promise.resolve();

        return Promise.all([this._loadGenAiConfigs(), licenseReady])
            .then(([[systemConfig, genAiConfig]]) => {
                this._setGenAiVisibilityAndEnablement(systemConfig, genAiConfig);
            })
            .catch((err) => {
                this._logger.error(
                    {error: err},
                    err,
                    "ControlAppNavAddon: _updateGenAiState - Cannot refresh GenAI state"
                );
            });
    }

    _loadGenAiConfigs() {
        const activeOrgId = _.get(this._userSession, "activeOrganization.id");
        return Promise.all([
            this._systemConfigEntityDef.loadSystemConfig(GSO_ID),
            this._genAiConfigEntityDef.loadAscendGenAiConfig(activeOrgId, {}),
        ]);
    }

    _setGenAiVisibilityAndEnablement(systemConfig, genAiConfig, userAuthorizedActions = undefined) {
        const authorizedActions =
            userAuthorizedActions || _.get(this._userSession, "user.authorizedActions", []);

        // Visibility: the global "Enable Gluware Titan Co-Pilot" setting
        // (Settings > Global > Configuration > Gluware Titan).
        this._genAiVisible = systemConfig ? systemConfig.getEnableGenAi() : false;

        const hasTAILicense = this._checkTAILicense();
        const hasLlmIds = Boolean(genAiConfig && genAiConfig.llmServiceConnectionId);

        this._genAiEnabled = hasTAILicense // TAI License : true
            ? hasLlmIds &&
              (authorizedActions.includes(TITAN_PERMISSION) ||
                  authorizedActions.includes(DOC_ASSIST_PERMISSION)) // LLM TRUE & TITAN Permission or Doc Assist permission true : true
            : authorizedActions.includes(DOC_ASSIST_PERMISSION);

        this._homebar.setGenAiVisibleAndEnable(this._genAiVisible, this._genAiEnabled);
    }

    _checkTAILicense() {
        const licenseRestriction = this._homebar && this._homebar.licenseRestriction;
        if (licenseRestriction) {
            // checkLicense returns true if license IS available
            return licenseRestriction.checkLicense(TAI_LICENSE);
        }
        return false;
    }

    _onVersionControlConfigChanged(entity, before) {
        if (
            entity.localEnabled !== before.localEnabled ||
            entity.pendingCommitCount !== before.pendingCommitCount
        ) {
            this._updateVersionControl(entity.localEnabled, entity.pendingCommitCount);
        }
    }

    _updateVersionControl(localEnabled, pendingCommitCount) {
        localEnabled = !!localEnabled;

        if (this._versionControlLocalEnabled !== localEnabled) {
            this._versionControlLocalEnabled = localEnabled;
            this._homebar.showVersionControl(localEnabled);
        }

        if (this._versionControlPendingCommitCount !== pendingCommitCount) {
            this._versionControlPendingCommitCount = pendingCommitCount;
            this._homebar.setVersionControlCount(pendingCommitCount);
        }
    }

    updateHomebarVersionControl() {
        const activeOrgId = _.get(this._userSession, "activeOrganization.id");

        // If user is not authenticated, data cannot be loaded
        if (!activeOrgId) {
            return;
        }

        return this._versionControlConfigEntityDef
            .loadVersionControlConfigs(activeOrgId)
            .then((loadedVersionControlConfigEntities) => {
                if (
                    loadedVersionControlConfigEntities &&
                    loadedVersionControlConfigEntities.length > 0
                ) {
                    const versionControlConfigInstance = loadedVersionControlConfigEntities[0];
                    return this._versionControlConfigEntityDef.retrieveVersionControlConfig(
                        activeOrgId,
                        versionControlConfigInstance.getId(),
                        {}
                    );
                }
                return [];
            })
            .then((versionControlConfigInstance) => {
                const activeSolution = _.get(this._solutionManager, "_activeSolution.name");
                this._unregisterVersionControlListeners();
                let localEnabled = false;
                if (!_.isEmpty(versionControlConfigInstance)) {
                    this._versionControlEntityInstance = versionControlConfigInstance;

                    this._registerVersionControlListeners();

                    localEnabled = this._versionControlEntityInstance.localEnabled;
                    const pendingCommitCount =
                        this._versionControlEntityInstance.pendingCommitCount;

                    this._updateVersionControl(localEnabled, pendingCommitCount);
                } else {
                    this._updateVersionControl(localEnabled, 0);
                }

                if (activeSolution === "version_control" && !localEnabled) {
                    const authorizedActions = _.get(this._userSession, "authorizedActions", []);
                    this._reRouteUser(authorizedActions);
                }
                return;
            })
            .catch((err) => {
                this._logger.error(
                    {error: err},
                    err,
                    "ControlAppNavAddon: _updateHomebarVersionControl - Cannot refresh Version Control solution icon"
                );
            });
    }

    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSectionChanged(sectionName) {
        document.title = _.get(this._section_titles, sectionName, this._section_titles.default);
    }

    _onActiveSolutionChanged(solDef) {
        let solutionLabel = _.get(solDef, "label", "");
        const currentSection = this._getCurrentSection();
        document.title = _.get(this._section_titles, currentSection, this._section_titles.default);
        if (_.isEmpty(solutionLabel) && currentSection === "Dashboard") {
            solutionLabel = DASHBOARD_TITLE;
        }
        this.setHomebar(solutionLabel, _.get(solDef, "iconName", "branding.control"));
    }

    _setInitialValuesOnHomeBar() {
        this._homebar.emitInitialValues();
    }

    _onAuthenticated(userEntity) {
        this._homebar.setUserData(userEntity);
        let orgToBeSelected = {},
            activeOrg,
            routeData = this._router.getRouteData();

        //this._localStorage.setUserId(userEntity.id);
        this._localStorage.setToken(this._userSession.token);
        this._homebar.setUserId(userEntity.userName);
        this._homebar.setName(userEntity.firstName + " " + userEntity.lastName, [
            userEntity.firstName,
            userEntity.lastName,
        ]);
        this._homebar.setEmail(userEntity.email);
        this._setHomebarRole(userEntity);
        this._setHomebarUserImage(userEntity).then(() => {
            this._homebar.setAIChat(this._genAiServiceIns);
        });

        this._setHomeBarOrganizations(userEntity.authorizedTenants);

        if (
            routeData &&
            routeData.activeOrganization &&
            userEntity.authorizedTenants[routeData.activeOrganization.id]
        ) {
            orgToBeSelected = {
                id: routeData.activeOrganization.id,
                name: userEntity.authorizedTenants[routeData.activeOrganization.id].name,
            };
        } else if (
            _.get(this._localStorage, "activeOrganization.id") &&
            _.get(this._localStorage, "activeOrganization.name") &&
            userEntity.authorizedTenants[this._localStorage.activeOrganization.id]
        ) {
            //jshint ignore:line
            activeOrg = this._localStorage.activeOrganization;
            orgToBeSelected = {
                id: activeOrg.id,
                name: activeOrg.name,
            };
        } else if (_.has(userEntity.authorizedTenants, userEntity.tenantId)) {
            orgToBeSelected = {
                name: userEntity.authorizedTenants[userEntity.tenantId].name,
                id: userEntity.tenantId,
            };
        } else {
            let orgId = Object.keys(userEntity.authorizedTenants)[0];
            orgToBeSelected = {
                name: userEntity.authorizedTenants[orgId].name,
                id: orgId,
            };
        }
        this._userSession.setActiveOrganization(orgToBeSelected, true);
        this._homebar.setActiveOrganization(orgToBeSelected);

        return this._storageFactory
            .loadUserPreferences()
            .then(() => {
                this._dataStorage = this._storageFactory.getRemoteStorageInstance("system", "core");

                //color theme-er
                let style = document.createElement("style");
                const userDataThemeStorage = this._storageFactory.getRemoteStorageInstance(
                    "user",
                    "theme"
                );
                const themeExplorerStorage = userDataThemeStorage.getData("explorer", true);
                if (themeExplorerStorage) {
                    const themeExplorer = themeExplorerStorage;
                    const hover = themeExplorer.colors.hover;
                    const selected = themeExplorer.colors.selected;

                    style.innerHTML = `:root { --hover: ${hover}; --selected: ${selected}; }`;
                    document.getElementsByTagName("head")[0].appendChild(style);
                }

                if (!routeData || !routeData.activeOrganization) {
                    activeOrg = this._dataStorage.getData("activeOrganization", true);
                    if (
                        activeOrg &&
                        userEntity.authorizedTenants[activeOrg.id] &&
                        orgToBeSelected !== activeOrg
                    ) {
                        orgToBeSelected = {
                            id: activeOrg.id,
                            name: activeOrg.name,
                        };
                    }
                }

                this._localStorage.setActiveOrganization(orgToBeSelected);
                this._userSession.setActiveOrganization(orgToBeSelected);
                return this._ControlUserEntity.loadControlUser(userEntity.tenantId, userEntity.id);
            })
            .then((controlUser) => {
                this._controluserInstance = controlUser;
                this._homebar.setControlUser(this._controluserInstance);
                if (controlUser.lastRoute) {
                    this._sessionStorage.setItem(
                        this._userSession.user.id + "lastPathInfo",
                        controlUser.lastRoute
                    );
                }

                return Promise.all([
                    this.updateHomebarVersionControl(),
                    this.updateHomebarIoT(),
                    this.getUserPreferences(),
                    this._updateGenAiState(),
                ]).then(() => {
                    this._homebar._buildVerticalMenuStart();
                    this._setInitialValuesOnHomeBar();
                    return Promise.resolve();
                });
            });
    }

    _onUnAuthenticated(cause) {
        // TODO Workaround to be fixed - cause type depends on source event
        if (typeof cause === "object") {
            cause = _.get(cause, "cause");
        }
        cause = cause || "unknown";

        const token = this._userSession.token || this._localStorage.getToken();
        this._sessionStorage.removeItem(token + "isBannerAccepted");
        localStorage.clear();
        this._controluserInstance = undefined;
        this._homebar.closeChatWindow(false, true);

        // After sign-out, the feature should not be advertised at all.
        this._genAiVisible = false;
        this._genAiEnabled = false;
        this._homebar.setGenAiVisibleAndEnable(false, false);

        if (!this._hasUserSignedOut) {
            this._userFeedback.renderer.rootElement.style.zIndex = 13;
            if (cause === "timeout") {
                this._userFeedback
                    .displayNotification("Session timed out due to inactivity.", {
                        notDismissable: true,
                        title: "Session Timed Out",
                        confirmDetails: {text: "Sign In Again"},
                    })
                    .then(() => {
                        this._userFeedback.renderer.rootElement.style.zIndex = "auto";
                        window.location = `${window.origin}/session/logout/${token}%2Ftimeout`;
                    });
            } else {
                Promise.resolve()
                    .then(() => {
                        if (cause) {
                            const msg =
                                "This session has ended because you have signed out from another window.";
                            return this._userFeedback.displayNotification(msg, {
                                title: "Session Signed Out",
                                notDismissable: true,
                                confirmDetails: {text: "Sign In Again"},
                            });
                        }
                    })
                    .then(() => {
                        this._userFeedback.renderer.rootElement.style.zIndex = "auto";
                        if (cause) {
                            const urlExtension = ["user", "banner", "eula", "reset"].includes(cause)
                                ? cause
                                : "user";
                            window.location.href = `${window.origin}/session/logout/${token}%2F${urlExtension}`;
                        } else {
                            this._routeToLogin();
                        }
                    });
            }
        }
    }

    _onNotAuthenticated() {
        let prom = Promise.resolve();
        if (this._token) {
            prom = this._connection.authenticate("OTK", this._token).then((response) => {
                //Put the token in the url and ask for a reload.
                this._logger.info({response: response}, "Re-authenticate response");
                return this._userFeedback.displayNotification(
                    "Socket disconnection occurred. Please click OK to refresh the browser.",
                    {notDismissable: true}
                );
            });
        } else {
            const token = this._userSession.token || this._localStorage.getToken();
            this._sessionStorage.removeItem(token + "isBannerAccepted");
            // this._setUrl();
        }
        prom.then(() => {
            this._router.reload();
        });
    }

    _onConnectionLost() {
        this._homebar.closeChatWindow(false, false);
        const routeDetails = _.omit(this._router.getRouteDetails(), ["rd.redirect"]);
        if (_.get(routeDetails, "s") !== "FailComms") {
            this._router.goTo({app: "GameConsole", s: "FailComms", rd: {redirect: routeDetails}});
        }
    }

    _onConnectionShutdown() {
        this._homebar.closeChatWindow(false, false);
        this._userFeedback
            .displayNotification("Socket disconnection occurred. Browser reload required.", {
                notDismissable: true,
                title: "Session Disconnected",
                confirmDetails: {text: "Reload"},
            })
            .then(() => {
                this._router.reload();
            });
    }
    _reRouteUser(authorizedActions) {
        if (authorizedActions.includes(SOLUTION_USER_PERM_MAP.dashboard)) {
            // this._router.goTo({ app: "GameConsole", s: "Dashboard", sln: null, sr: null, rd: {}, ra: "dashboard" });
            window.location =
                window.origin + "/#!/_app_/GameConsole/_s_/Dashboard/_rd_/JTdCJTdE/_ra_/dashboard";
        } else if (authorizedActions.includes(SOLUTION_USER_PERM_MAP.DeviceManager)) {
            this._router.goTo({app: "GameConsole", s: "GameCenter", sln: "DeviceManager"});
        } else {
            this._router.goTo({
                app: "GameConsole",
                s: "Settings",
                sln: "Settings",
                sr: "User/EditMyProfile",
            });
        }
    }
    _onRouteInfoChanged(newRoute, oldRoute, details) {
        const changeCause = _.get(details, "sourceDetails.causedBy", undefined);

        if (newRoute.s === "RoboHelp") {
            return;
        }

        // Commented code to take user to last visited solution. For 4.2
        // if(newRoute.s === "LoginCenter"
        //     && this._localStorage.getToken()
        //     && this._userSession.user) {
        //     let lastPathInfo = window.sessionStorage.getItem(this._userSession.user.id+"lastPathInfo");
        //     if(lastPathInfo) {
        //         if(lastPathInfo.search("/s/Perspective/") >= 0) {
        //             window.location.href = window.origin + '/_app_/gluware_control/#!' + lastPathInfo;
        //             return;
        //         } else {
        //             window.location.hash = "#!" + lastPathInfo;
        //             return;
        //         }
        //     }
        // }

        // Case 26071 - Logout if user lands on Login Page
        const token = this._userSession.token || this._localStorage.getToken();
        if ((newRoute.s === "LoginCenter" || newRoute.s === "LogoutCenter") && token) {
            this._onHomeBarRequestedLogout();
            return false;
        }

        // Case 25733 - Redirect to dashboard if newRoute.s is false value
        if (!newRoute.s) {
            window.location =
                window.origin + "/#!/_app_/GameConsole/_s_/Dashboard/_rd_/JTdCJTdE/_ra_/dashboard";
        }
        /* If section changes without solution change call method to update title */
        if (newRoute.sln === oldRoute.sln && newRoute.s !== oldRoute.s) {
            this._onActiveSolutionChanged(this._solutionManager.activeSolution);
        }

        /* Permission check and re-route */
        let soln = newRoute.sln;
        this._homebar.emit("routeChanged", newRoute);
        if (newRoute.s === "Dashboard") {
            soln = "dashboard";
        }
        if (
            oldRoute.s === "Dashboard" &&
            newRoute.s !== "Dashboard" &&
            typeof window.stopReactApp === "function"
        ) {
            window.stopReactApp();
        }
        if (soln && soln !== oldRoute.sln && soln !== "Settings" && this._userSession.user) {
            const authorizedActions = this._userSession.user.authorizedActions;
            if (!authorizedActions.includes(SOLUTION_USER_PERM_MAP[soln])) {
                return _.delay(() => this._reRouteUser(authorizedActions), 150);
            }
        }
        /* ----------------------------- */
        if (
            changeCause === "HashChange" &&
            this._controluserInstance &&
            newRoute.s !== "LoginCenter" &&
            newRoute.s !== "Banner" &&
            newRoute.s !== "Eula" &&
            newRoute.s !== "RoboHelp" &&
            newRoute.s !== "PasswordReset" &&
            newRoute.s.toLowerCase().search("fail") < 0 &&
            newRoute.s !== "LogoutCenter"
        ) {
            const lastSoln = newRoute.url.split("#!")[1];

            // Validate route before saving to prevent malformed routes from being stored
            // Hash routes should not contain protocols or nested URLs
            const isValidRoute =
                lastSoln &&
                !lastSoln.includes("://") &&
                !lastSoln.includes("http") &&
                lastSoln.startsWith("/");

            if (isValidRoute && lastSoln !== this._controluserInstance.lastRoute) {
                this._controluserInstance.setLastRoute(lastSoln);
                this._controluserInstance
                    .update()
                    .then(() => {
                        this._sessionStorage.setItem(
                            this._userSession.user.id + "lastPathInfo",
                            lastSoln
                        );
                    })
                    .catch((err) => {
                        this._logger.warn("Unable to save last solution info.", err);
                    });
            }
            this.updateHomebarIoT();
        }
    }

    _onHomeBarRequestedLogout() {
        const token = this._userSession.token || this._localStorage.getToken();
        this._homebar.blur();
        this._homebar.closeChatWindow(false, true);
        this.logoutPrecheck()
            .then(() => {
                this._sessionStorage.removeItem(token + "isBannerAccepted");
                localStorage.clear();
                this._controluserInstance = undefined;
                this._hasUserSignedOut = true;
                this._logoutPreChecks = [];
                location.href = `${window.origin}/session/logout/${token}%2Fuser`;
            })
            .catch((err) => {
                this._logger.warn({error: err}, "AppSolutionSwitcher._onHomebarRequestedLogout");
            });
    }

    _onHomeBarRequestedNavigateToDashboard() {
        // this.emit("ShutdownCurrentSection");
        this.routeToDashboard();
    }

    _onHomeBarRequestedHelp() {
        this._homebar.blur();
        //let solnHelpLink = _.get(this._solutionManager.activeSolution, "helpLink", null);

        //read directly from DOM for more fidelity than just solution level help, if possible
        //dashboards can be set specifically now like setting sections...fixes TOTO below?
        let solnHelpLink = this._homebar._renderer.helpIconContainer.getAttribute("help-link");

        // TODO: Case 24543 - Find a good way to have solnHelpLink work on Dashboard
        // even though Dashboard is not a 'solution'
        if (solnHelpLink) {
            this._router.navigateToHelpTab(
                {app: "GameConsole", s: "RoboHelp", sln: solnHelpLink},
                "robohelp"
            );
        } else {
            this._router.navigateToHelpTab(
                {app: "GameConsole", s: "RoboHelp", sln: "Dashboards/Dashboard-overview.htm"},
                "robohelp"
            );
        }
    }

    _onHomeBarRequestedOrganizationChange(orgObj) {
        this._userSession.setActiveOrganization(orgObj);
    }

    _onOrganizationChanged(orgObj, oldOrg) {
        this.getUserPreferences()
            .then(() => {
                this._localStorage.setActiveOrganization(orgObj);
                //modelEditor hack
                if (this._dataStorage) {
                    this._dataStorage.setData(orgObj, "activeOrganization");
                }
                // GenAiConfig is per-org, so the Titan icon visibility must be re-evaluated
                // whenever the active organization changes (e.g. TAI license inherited from
                // a parent org but service connections not shared with the current org).
                return Promise.all([
                    this.updateHomebarVersionControl(),
                    this.updateHomebarIoT(),
                    this._updateGenAiState(),
                ]);
            })
            .then(() => {
                this._homebar.setActiveOrganization(orgObj, true);
                this.emit("OrganizationChanged", orgObj, oldOrg);
                return Promise.resolve();
            });
    }

    _onHomeBarAutoShow() {
        let section = document.querySelector(".current_section");
        if (section !== null) {
            section.classList.add("homebar-shown");
        }
    }

    _onHomeBarAutoHide() {
        let section = document.querySelector(".current_section");
        section.classList.remove("homebar-shown");
    }

    /*******************************************/
    /* END HANDLER API METHODS                 */
    /*******************************************/
    _setHomeBarOrganizations(authOrgList) {
        let orgOptions = [];
        Object.keys(authOrgList).forEach((orgId) => {
            const org = authOrgList[orgId];
            const name = _.get(org, "name");
            if (orgId && name) {
                orgOptions.push({
                    label: name,
                    value: {name: name, id: orgId},
                    description: _.get(org, "description", name),
                });
            }
        });
        this._homebar.setOrganizations(
            _.sortBy(orgOptions, [
                (org) => {
                    return _.lowerCase(org.label);
                },
            ])
        );
    }

    _getCurrentSection() {
        let routeDetails = this._router.getRouteDetails();
        return _.get(routeDetails, "s");
    }

    /**
     *
     * @param {function | string} preCheck - if function provided, then this funcntion will be called before logout, if string then confirmation veil will be opened
     */
    addLogoutPrecheck(preCheck) {
        this._logoutPreChecks = this._logoutPreChecks || [];
        this._logoutPreChecks.push(preCheck);
        return this;
    }
    removeLogoutPrecheck(preCheck) {
        const idx = this._logoutPreChecks.indexOf(preCheck);
        if (idx >= 0) {
            this._logoutPreChecks.splice(idx, 1);
        }
        return this;
    }

    /**
     *
     * @returns {Promise<*>}
     */
    logoutPrecheck() {
        const preChecks = this._logoutPreChecks.map((preCheck) => {
            if (typeof preCheck === "string") {
                return () => this.displayLogoutConfirmation(preCheck, {dontHide: true});
            }
            if (typeof preCheck === "function") {
                return () => Promise.resolve(preCheck());
            }
            return () => {};
        });

        return preChecks
            .reduce((preCheckPromise, checkFn) => preCheckPromise.then(checkFn), Promise.resolve())
            .then(
                () => {
                    this._userFeedback.hideDisplayed();
                },
                (err) => {
                    this._userFeedback.hideDisplayed();
                    throw err;
                }
            );
    }

    displayLogoutConfirmation(msg, opts) {
        opts = Object.assign(
            {
                title: "Sign Out Confirmation",
                confirmDetails: {
                    text: "Yes",
                    type: "destructive",
                },
                rejectDetails: {
                    text: "No",
                    type: "text",
                },
            },
            opts
        );
        return this._userFeedback.displayConfirmation(msg, opts);
    }
}

module.exports = ControlAppNavAddon;
module.exports.$inject = [
    "$teve.logger",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.router",
    "$teve.userLocalStorage",
    "$teve.solutionsManager",
    "$teve.storageFactory",
    "$teve.entities.ControlUser",
    "$teve.entities.ActionGroup",
    "$teve.entities.OsUpgradePlanPrefs",
    "$teve.services.GenAi",
    "$teve.entities.SystemConfig",
    "$teve.entities.VersionControlConfig",
    "$teve.entities.DataSyncConfig",
    "$teve.entities.GenAiConfig",
];
